/*
  HoS Mobile Mega Menu — Vanilla JS controller
  Handles: drawer open/close, slide-in submenus, brand filtering, body lock.
*/
(function () {
  const scrim = document.querySelector('[data-hos-mm-scrim]');
  const drawer = document.querySelector('[data-hos-mm-drawer]');
  if (!drawer || !scrim) return;

  const body = document.body;
  const closeBtn = drawer.querySelector('[data-hos-mm-close]');
  const subPanels = drawer.querySelectorAll('[data-hos-mm-sub]');
  const openSubBtns = drawer.querySelectorAll('[data-hos-mm-open-sub]');
  const backBtns = drawer.querySelectorAll('[data-hos-mm-back]');

  let activeSubIndex = null;

  function openDrawer() {
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    body.classList.add('hos-mm-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    body.classList.remove('hos-mm-open');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(closeAllSubs, 320);
  }

  function openSub(index) {
    closeAllSubs();
    const panel = drawer.querySelector(`[data-hos-mm-sub="${index}"]`);
    if (panel) {
      panel.classList.add('is-open');
      activeSubIndex = index;
    }
  }

  function closeAllSubs() {
    subPanels.forEach(function (p) { p.classList.remove('is-open'); });
    activeSubIndex = null;
  }

  /* Drawer triggers — hook into existing Palo Alto burger button */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mobile-menu-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }
  });

  /* Close */
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  scrim.addEventListener('click', closeDrawer);

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      if (localePanel && localePanel.classList.contains('is-open')) {
        closeLocale();
      } else if (activeSubIndex !== null) {
        closeAllSubs();
      } else {
        closeDrawer();
      }
    }
  });

  /* Open submenu */
  openSubBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var idx = btn.getAttribute('data-hos-mm-open-sub');
      openSub(idx);
    });
  });

  /* Back buttons */
  backBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeAllSubs();
    });
  });

  /* Brand filter */
  var brandFilters = drawer.querySelectorAll('[data-hos-mm-brand-filter]');
  brandFilters.forEach(function (input) {
    input.addEventListener('input', function () {
      var query = input.value.toLowerCase().trim();
      var wrap = input.closest('[data-hos-mm-brands]');
      if (!wrap) return;
      var items = wrap.querySelectorAll('[data-brand-name]');
      var headings = wrap.querySelectorAll('[data-hos-mm-az-group]');
      var azBar = wrap.querySelector('[data-hos-mm-az-bar]');

      items.forEach(function (item) {
        var name = item.getAttribute('data-brand-name');
        if (!query || name.indexOf(query) !== -1) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });

      headings.forEach(function (h) {
        var letter = h.getAttribute('data-hos-mm-az-group');
        var hasVisible = wrap.querySelector('[data-brand-letter="' + letter + '"]:not([hidden])');
        h.style.display = hasVisible ? '' : 'none';
      });

      if (azBar) azBar.style.display = query ? 'none' : '';
    });
  });

  /* A-Z jump navigation */
  var azBars = drawer.querySelectorAll('[data-hos-mm-az-bar]');
  azBars.forEach(function (bar) {
    var wrap = bar.closest('[data-hos-mm-brands]');
    var list = wrap ? wrap.querySelector('[data-hos-mm-brands-list]') : null;
    if (!list) return;

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hos-mm-az-jump]');
      if (!btn) return;
      var letter = btn.getAttribute('data-hos-mm-az-jump');
      var target = list.querySelector('[data-hos-mm-az-group="' + letter + '"]');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      bar.querySelectorAll('.hos-mm-az-letter').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });

    /* Highlight active letter on scroll */
    var scrollTimer;
    list.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var headings = list.querySelectorAll('[data-hos-mm-az-group]');
        var activeLetter = null;
        headings.forEach(function (h) {
          if (h.style.display === 'none') return;
          var rect = h.getBoundingClientRect();
          var listRect = list.getBoundingClientRect();
          if (rect.top <= listRect.top + 50) {
            activeLetter = h.getAttribute('data-hos-mm-az-group');
          }
        });
        bar.querySelectorAll('.hos-mm-az-letter').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-hos-mm-az-jump') === activeLetter);
        });
      }, 60);
    });
  });

  /* Locale panel */
  var localePanel = drawer.querySelector('[data-hos-mm-locale-panel]');
  var localeOpenBtn = drawer.querySelector('[data-hos-mm-open-locale]');
  var localeBackBtn = localePanel ? localePanel.querySelector('[data-hos-mm-locale-back]') : null;

  function openLocale() {
    if (localePanel) localePanel.classList.add('is-open');
  }
  function closeLocale() {
    if (localePanel) localePanel.classList.remove('is-open');
  }

  if (localeOpenBtn) localeOpenBtn.addEventListener('click', openLocale);
  if (localeBackBtn) localeBackBtn.addEventListener('click', closeLocale);

  /* Locale selection → form submit */
  if (localePanel) {
    localePanel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hos-mm-locale-select]');
      if (!btn) return;
      var raw = btn.getAttribute('data-hos-mm-locale-select');
      var parts = raw.split(':');
      var form = localePanel.querySelector('#HosMmLocaleForm');
      if (!form || parts.length < 2) return;

      if (parts[0] === 'locale') {
        var localeInput = form.querySelector('[data-hos-mm-locale-input]');
        if (localeInput) localeInput.value = parts[1];
      } else if (parts[0] === 'country') {
        var countryInput = form.querySelector('[data-hos-mm-country-input]');
        if (countryInput) countryInput.value = parts[1];
        if (parts[2]) {
          var localeInputC = form.querySelector('[data-hos-mm-locale-input]');
          if (localeInputC) localeInputC.value = parts[2];
        }
      }

      form.submit();
    });
  }

  /* Prevent Palo Alto's own drawer from opening on mobile-menu-trigger */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-trigger]')) {
      var paDrawer = document.querySelector('.js-drawer-open');
      if (paDrawer && paDrawer !== e.target.closest('[data-mobile-menu-trigger]')) {
        return;
      }
    }
  }, true);
})();
